import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { InfoIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Notfound404Page = () => {
  const navigate = useNavigate();
  return (
    <div className="-translate-x-/2 -translate-y-/2 fixed left-1/2 top-1/2 ">
      <div className="flex w-full flex-col items-center justify-center gap-1">
        <InfoIcon width={40} height={40} />
        <h3 className="text-xl font-semibold">Not found</h3>
        <Label className="opacity-50">
          We could not find the page you were looking for
        </Label>
        <Button
          className="mt-[10px]"
          type="button"
          onClick={() => {
            navigate('/');
            navigate(0);
          }}
        >
          Back to home
        </Button>
      </div>
    </div>
  );
};
export default Notfound404Page;
